<template>
  <v-form @submit.prevent="updateMe" v-model="isFormValid" ref="form">
    <v-container>
      <v-row align="center">
        <!-- Avatar and Name -->
        <v-col cols="auto">
          <v-avatar size="64">
            <!-- Replace src with actual image source -->
            <img :src="avatarSrc" alt="User Avatar" />
          </v-avatar>
        </v-col>
        <v-col cols="auto">
          <div class="name">
            <h3>{{ receivedUser.name }}</h3>
          </div>
        </v-col>

        <!-- Spacer -->
        <v-col></v-col>

        <!-- Edit Button -->
        <v-col cols="auto">
          <input
            type="file"
            ref="fileInput"
            style="display: none"
            @change="handleFileChange"
            accept="image/*"
          />
          <v-btn outlined color="primary mr-0" @click="openFileInput"
            >Edit Avatar</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <div class="mb-1 subtitle-2 grey3--text">User name</div>
    <v-text-field
      v-model="username"
      placeholder="Mr nice"
      :rules="usernameRules"
      outlined
      dense
    ></v-text-field>
    <div class="mb-1 subtitle-2 grey3--text">Full name (as in ID)</div>
    <v-text-field
      v-model="name"
      placeholder="Full name"
      :rules="fullNameRules"
      outlined
      dense
    ></v-text-field>
    <div class="mb-1 subtitle-2 grey3--text">Email</div>
    <v-text-field
      v-model="email"
      placeholder="example@gmail.com"
      :rules="emailRules"
      outlined
      dense
    ></v-text-field>
    <div class="mb-1 subtitle-2 grey3--text">
      Phone number (m-pesa registered)
    </div>
    <v-text-field
      v-model="phone"
      placeholder="07xxxxxxxx"
      :rules="phoneNumberRules"
      outlined
      dense
    ></v-text-field>
    <v-btn
      class="mt-2 primary white--text lowercase-text"
      block
      plain
      :loading="$store.state.loading.updateMeBtn.load"
      :disabled="$store.state.loading.updateMeBtn.disabled"
      type="submit"
    >
      Save changes
    </v-btn></v-form
  >
</template>

<script>
export default {
  data() {
    return {
      avatarSrc: this.$store.state.user.data.user.photo,
      photo: null,
      username: this.$store.state.user.data.user.username,
      name: this.$store.state.user.data.user.name,
      email: this.$store.state.user.data.user.email,
      phone: "0" + this.$store.state.user.data.user.phone,
      isFormValid: false,
      usernameRules: [
        (v) => !!v || "Username is required",
        (v) => (v && v.length >= 3) || "Username must be at least 3 characters",
        (v) =>
          /^[a-zA-Z0-9_]+$/.test(v) ||
          "Username can only contain letters, numbers, and underscores",
      ],
      fullNameRules: [
        (v) => !!v || "Full name is required",
        (v) =>
          /^[a-zA-Z\s]*$/.test(v) ||
          "Full name must contain only letters and spaces",
      ],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      phoneNumberRules: [
        (v) => !!v || "Phone number is required",
        (v) => /^[0-9]{10}$/.test(v) || "Phone number must be 10 digits",
      ],
    };
  },
  computed: {
    receivedUser() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    async updateMe() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        const formData = new FormData();
        formData.append("username", this.username);
        formData.append("name", this.name);
        formData.append("email", this.email);
        formData.append("phone", this.phone);
        formData.append("photo", this.photo);

        // Send formData to your server or perform desired actions
        await this.$store.dispatch("updateMe", formData);
      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      this.photo = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.avatarSrc = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
